<template>
    <div v-if="show_item" class="quiz__campaign__endpoint-share">
        <h2 class="quiz__campaign__endpoint-title">{{ content.title }}</h2>
        <div>
            <a class="social-share" :href="'https://twitter.com/intent/tweet/?text=' + endpoint.title + '%20-%20' + campaign.links.start + twitterHandle + twitterHashtag" title="Share on Twitter" target="_blank">
                <i class="icon-twitter"></i>
            </a>
            <a class="social-share" :href="'https://www.facebook.com/sharer/sharer.php?u=' + campaign.links.start" title="Share on Facebook" target="_blank">
                <i class="icon-facebook"></i>
            </a>
            <a class="social-share" :href="'mailto:?&subject=' + endpoint.title + '&body='+ campaign.links.start" title="Share by Email">
                <i class="icon-email"></i>
            </a>
        </div>
    </div>
</template>
<script>
export default {
    props: ['content', 'campaign', 'endpoint'],
    data() {
        return {
            show_item: false
        }
    },
    mounted() {
        this.show_item = true;
    },
    computed: {
        twitterHashtag : function(){
            let accounts = this.endpoint.campaign.social_accounts;
            let max = this.endpoint.campaign.social_accounts.length;
            let x;
            let hashtag = '';
            for( x = 0; x < max; x++ ){
                if( accounts[x].content == 'Twitter' && accounts[x].hashtag !== 'null' )
                {
                    hashtag = '&amp;hashtags=' + accounts[x].hashtag;
                }
            }
            return hashtag;
        },
        twitterHandle : function() {
            let accounts = this.endpoint.campaign.social_accounts;
            let max = this.endpoint.campaign.social_accounts.length;
            let x;
            let handle = '';
            for( x = 0; x < max; x++ ){
                if( accounts[x].content == 'Twitter' && accounts[x].handle !== null )
                {
                    handle = '&amp;via=' + accounts[x].handle;
                }
            }
            return handle;
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/content-blocks/share.vue